import PropTypes from 'prop-types'
import React from 'react'

import LicenseInfo from '../../../shared/LicenseInfo/LicenseInfo'
import './Footer.scss'

export const githubOrgUrl = 'https://github.com/RaspberryPiLearning'
export const projectRepoUrl = (slug) => `${githubOrgUrl}/${slug}`

const Footer = ({ slug }) => {
  return (
    <footer className="c-print-footer">
      <LicenseInfo projectRepoUrl={projectRepoUrl(slug)} />
    </footer>
  )
}

Footer.propTypes = {
  slug: PropTypes.string.isRequired,
}

export default Footer
